import { DateTime } from 'luxon';
import { DictionaryEntry } from '@sdbn/common';

export class SearchArticleResult {

  id: number;
  name: DictionaryEntry;
  identifier: string;
  archived: boolean;
  retailPriceDaily: Price;

  constructor(result: any) {
      this.id = result.id;
      this.name = new DictionaryEntry(result.name);
      this.identifier = result.identifier;
      this.archived = result.archived;
      this.retailPriceDaily = result.retailPriceDaily;
  }

}

export class SearchArticle {

  query: string;
  includeArchived = false;

  constructor(search: any) {
      this.query = search.query;
      this.includeArchived = search.includeArchived === true;
  }

}

export class Period {
    from: Date;
    until: Date;

    constructor(period: any) {

        if (period.from != null) {
            const date = DateTime.fromISO(period.from);
            if (date.isValid) {
                this.from = new Date(date.year, date.month - 1, date.day);
            }
        }
        if (period.until != null) {
            const date = DateTime.fromISO(period.until);
            if (date.isValid) {
                this.until = new Date(date.year, date.month - 1, date.day);
            }
        }
    }
}

export class Description {
    id: number;
    usage: string;
    deleted = false;
    title = new DictionaryEntry();
    text = new DictionaryEntry();

    constructor(description: any) {
        console.log('processing ', description);
        this.id = description.id != null ? description.id : 0;
        this.usage = description.usage;
        this.deleted = description.deleted === true;
        if (description.title != null) {
            this.title = new DictionaryEntry(description.title);
        }
        if (description.text != null) {
            this.text = new DictionaryEntry(description.text);
        }
    }
}

export class PriceContainer {

    id: number;

    costsPrices = new Array<CostsPrice>();
    retailPrices = new Array<RetailPrice>();

    constructor(container: any) {
        if (container.costsPrices != null) {
            for (let price of container.costsPrices) {
                this.costsPrices.push(new CostsPrice(price));
            }
            this.sortPrices(this.costsPrices);
        }
        if (container.retailPrices != null) {
            for (let price of container.retailPrices) {
                this.retailPrices.push(new RetailPrice(price));
            }
            this.sortPrices(this.retailPrices);
        }
    }

    public sortCostsPrices() {
        if (this.costsPrices != null) {
            this.sortPrices(this.costsPrices);
        }
    }

    public sortRetailPrices() {
        if (this.retailPrices != null) {
            this.sortPrices(this.retailPrices);
        }
    }

    private sortPrices(prices: Array<Price>) {
        prices.sort((cp1, cp2) => {

            const price1From = cp1.validPeriod?.from != null ? cp1.validPeriod?.from?.getTime() : 0;
            const price1Until = cp1.validPeriod?.until != null ? cp1.validPeriod?.until?.getTime() : 0;

            const price2From = cp2.validPeriod?.from != null ? cp2.validPeriod?.from?.getTime() : 0;
            const price2Until = cp2.validPeriod?.until != null ? cp2.validPeriod?.until?.getTime() : 0;

            let diff = price1From - price2From;
            if (diff === 0) {
                diff = price1Until - price2Until;
            }
            return diff;
          });
    }

}

export class Price {

    id: number;
    deleted = false;

    referenceDate: string;
    validPeriod = new Period({});
    taxRate: number;
    priceNet: number;
    priceVat: number;

    // Datenstruktur wird exklusiv im Client genutzt.
    valuesMap = new Map<string, string>();

    constructor(price: any) {
      if (price.referenceDate != null) {
        this.referenceDate = price.referenceDate;
      }
      this.deleted = price.deleted === true;
      if (price.validPeriod != null) {
          this.validPeriod = new Period(price.validPeriod);
      }
      this.taxRate = price.taxRate != null ? price.taxRate : null;
      this.priceNet = price.priceNet != null ? price.priceNet : null;
      this.priceVat = price.priceVat != null ? price.priceVat : null;
    }

}

export class CostsPrice extends Price {

    source: string;

    // Schnittstellenobject zum Server
    values: any = {};

    constructor(price: any) {
        super(price);
        this.source = price.source;
        if (price.values != null) {
          for (const k of Object.keys(price.values)) {
            this.values[k] = price.values[k];
            this.valuesMap.set(k, price.values[k]);
          }
        }
    }

    public getValueByAttributeId(attributeId: number): string {
      return this.valuesMap.get(attributeId + '');
    }

    /**
     * Befüllt das Attribut "values" der Serverschnittstelle basierend auf der im Client
     * verwendeten Map "valuesMap".
     */
    public fillValuesFromValuesMap() {
      this.values = {};
      this.valuesMap.forEach((val: string, key: string) => {
        this.values[key] = val;
      });
    }

}

export class RetailPrice extends Price {

    calculationValues = new Array<RetailPriceCalculationValue>();
    useBasicPrice = false;

    constructor(price: any) {
        super(price);

        if (price.calculationValues != null) {
            for (let value of price.calculationValues) {
                this.calculationValues.push(new RetailPriceCalculationValue(value));
            }
        }

        if (price.useBasicPrice != null) {
            this.useBasicPrice = price.useBasicPrice;
        }
    }

    public getValueByRuleId(id: number): RetailPriceCalculationValue {
        for (let value of this.calculationValues) {
            if (value.ruleAttributeId == id) {
                return value;
            }
        }
    }

}

export class RetailPriceCalculationValue {

    id: number;
    ruleAttributeId: number;
    count: number;
    value: number;

    total: number;

    constructor(value: any) {
        this.id = value.id;
        this.ruleAttributeId = value.ruleAttributeId;
        this.count = value.count;
        this.value = value.value;
    }

    public calculate() {
        if (this.count != null && this.value != null) {
            this.total = this.count * this.value;
        } else {
            this.total = 0;
            console.log('no calculation for', this.count, this.value);
        }
    }

}
